import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import { ISelectedBlog, ISelectedBlogExtraProps } from '../Blog.types';
import BlogPost from '../BlogPost';
import Newsletter from '../Newsletter';
import RelatedBlogs from '../RelatedBlogs';
import SelectedBlogStyles from './SelectedBlog.module.scss';
import SideControls from './SideControls';

type IProps = ISelectedBlog & ISelectedBlogExtraProps;

const SelectedBlog = ({ data, relatedPosts }: IProps) => {
  const { t } = useTranslation('resources');

  const { selectedBlog } = t('blog', {
    returnObjects: true,
  }) as any;

  return (
    <div className={SelectedBlogStyles.selectedBlog}>
      <div className={SelectedBlogStyles.mainInfo}>
        <BlogPost data={data} />

        <div
          className={classNames(SelectedBlogStyles.blogControls, SelectedBlogStyles.showOnTablet)}
        >
          <SideControls />
        </div>

        {relatedPosts && <RelatedBlogs relatedPosts={relatedPosts} />}

        <div className={classNames(SelectedBlogStyles.showOnTablet)}>
          <Newsletter
            data={{ ...selectedBlog?.newsletter, variant: 'blogControls_selectedBlog' }}
          />
        </div>
      </div>

      <div
        className={classNames(
          SelectedBlogStyles.blogControls,
          SelectedBlogStyles.showOnDesktopOnly
        )}
      >
        <SideControls />
      </div>
    </div>
  );
};

export default SelectedBlog;
